import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { setGuideMeOpened } from 'containers/HomePage/actions';
import GuideMeButton from '../components/GuideMeButton';
import FeaturedResources from '../components/VariantD/FeaturedResources';
import Intro from '../components/Intro';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '82px 0 82px 0',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      padding: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  container: {
    [theme.breakpoints.up('1140')]: {
      width: 1140,
      padding: 0,
    },
    width: '100%',
    '& > div': {
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '0px !important',
        paddingRight: '0px !important',
      },
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: 20,
    },
    [theme.breakpoints.down('xs')]: {
      padding: '20px 5%',
    },
  },
}));

function VariantD() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const hasAutoPopup = sessionStorage.getItem('autopopup') === 'false';

  useEffect(() => {
    if (!hasAutoPopup) {
      dispatch(setGuideMeOpened(true));
    }
  }, []);

  return (
    <div className={classes.root} data-test-id="hero-variant-c">
      <Grid
        container
        className={classes.container}
        direction="row"
        spacing={4}
        alignItems="center"
      >
        <Grid item xs={12} sm={12} md={3}>
          <Grid container direction="column">
            <Intro fontSize={35} />
            <GuideMeButton />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={9}>
          <FeaturedResources />
        </Grid>
      </Grid>
    </div>
  );
}

export default React.memo(VariantD);
